<template>
    <div :class="classes">
        <Button v-if="showArrows" :disabled="!hasPrevious" class="left tab-carousel-arrow" @click="switchPage(-1)">
            <Icon type="ios-arrow-back" size="24" />
        </Button>
        <slot />
        <Button v-if="showArrows" :disabled="!hasNext" class="right tab-carousel-arrow" @click="switchPage(1)">
            <Icon type="ios-arrow-forward" size="24" />
        </Button>
    </div>
</template>

<script lang="ts">
export default {
    name: "TabCarousel",
    props: {
        padding: {
            type: String,
            default: "large"
        },

        showArrows: {
            type: Boolean,
            default: true
        },

        totalPages: {
            type: Number,
            required: true
        },

        modelValue: {
            type: Number,
            required: true
        }
    },

    emits: ["update:modelValue"],

    computed: {
        classes() {
            const classes = ["tab-carousel"];

            if (this.padding) {
                classes.push(`padding-${this.padding}`);
            }

            return classes;
        },

        hasNext() {
            return this.modelValue !== this.totalPages;
        },

        hasPrevious() {
            return this.modelValue !== 1;
        }
    },

    methods: {
        setPageNumber(number: number) {
            this.$emit("update:modelValue", number);
        },

        switchPage(dir: number) {
            if (this.modelValue + dir < 1) {
                this.setPageNumber(this.totalPages);
                return;
            }

            if (this.modelValue + dir > this.totalPages) {
                this.setPageNumber(1);
                return;
            }

            this.setPageNumber(this.modelValue + dir);
        }
    }
};
</script>

<style lang="scss">
@use "@style/variables" as *;

.tab-carousel {
    position: relative;

    &-arrow {
        border: none;
        outline: none;

        padding: 0;
        margin: 0;

        width: 44px;
        height: 44px;
        border-radius: 50%;

        cursor: pointer;

        position: fixed;
        top: 50%;
        z-index: 10;
        transform: translateY(-50%);

        display: flex;
        justify-content: center;
        align-items: center;

        background-color: $white;
        color: $cmp-light-font-color;
        box-shadow: 0 3px 15px rgba(0, 0, 0, 0.15);

        text-align: center;
        font-size: 1em;

        &:focus {
            box-shadow: 0 3px 15px rgba(0, 0, 0, 0.15);
        }

        &:hover {
            box-shadow: 0 3px 15px rgba(0, 0, 0, 0.05);
        }

        &.left {
            left: $spacing-large;
        }

        &.right {
            right: $spacing-large;
        }
    }

    &.padding-semi-large {
        .left {
            left: $spacing-semi-large;
        }

        .right {
            right: $spacing-semi-large;
        }
    }

    &.padding-base {
        .left {
            left: $spacing-base;
        }

        .right {
            right: $spacing-base;
        }
    }

    &.padding-semi-small {
        .left {
            left: $spacing-semi-small;
        }

        .right {
            right: $spacing-semi-small;
        }
    }
}
</style>
